import React from "react";

export default function Logos() {
  const logos = [
    { name: "Solana", src: "/assets/solana.png", alt: "Solana", href: "https://solana.com" },
    { name: "Phantom", src: "/assets/phantom.png", alt: "Phantom Wallet", href: "https://phantom.com" },
  ];
  return (
    <section className="relative overflow-hidden" data-reveal>
      <div className="mx-auto max-w-6xl px-4 py-10 relative">
        <div className="mx-auto grid w-full grid-cols-2 items-center gap-6 md:gap-10">
          {logos.map((it, idx) => (
            <div key={it.name} data-reveal style={{ ['--reveal-delay' as any]: `${idx * 90}ms` }} className="flex items-center justify-center">
              <a
                href={it.href}
                target="_blank"
                rel="noreferrer noopener"
                className="group inline-flex items-center justify-center opacity-80 transition-all hover:opacity-100 hover:drop-shadow-[0_0_18px_rgba(99,102,241,0.35)]"
                aria-label={it.name}
              >
                <img src={it.src} alt={it.alt} className="h-7 w-auto md:h-9 lg:h-10 object-contain" />
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
